<div class="content-body">
  <div class="row form-head mt-4 mx-1">
    <div>
      <a [routerLink]="['/invoices/historical-data/historical-invoices']" class="ac-goback-btn" >
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z"/></svg>
      Go Back </a>
    </div>
  </div>
    <div class="container-fluid mt-4">
      <div class="row d-sm-flex d-block align-items-center mb-4">
        <div class="d-sm-flex rowp d-block align-items-center mb-4">
          <div class="me-auto d-sm-flex" style="align-items: center; display: -webkit-inline-box;">
            <h2 class="text-black font-w600 mb-0 ac-inv-no">Invoice: 
              <span class="font-w400 ps-2 pe-3">{{invoice.invoice_id}}</span>
            </h2>
            <a href="javascript:void(0)" class="badge {{invoice.status_class}} pt-1"
               [style.backgroundColor]="invoice.statusColor"
               [ngStyle]="{
                 'color': (invoice.status === 'Not Paid') ? '#FA4628' : 
                           (invoice.status === 'Paid') ? '#028402' : 
                           (invoice.status === 'Partially Paid') ? '#fa783b' : ''
               }">{{invoice.status}}</a>
          </div>
        </div>
      </div>
  
      <div class="row">
        <div class="col-lg-12 ac-inv-head">
          <h2>Invoice Details</h2>
          <p style="border-bottom:1px solid #d1d1d1;">Details</p>
  
          <div class="row d-flex justify-content-between mt-4 mb-3">
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Account No.</h6>
              <p>{{invoice.bpNo}}</p>
            </div>
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Invoice No.</h6>
              <p>{{invoice.invoice_id}}</p>
            </div>
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Invoice Date</h6>
              <p>{{invoice.date}}</p>
            </div>
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>Due Date</h6>
              <p>{{invoice.dueDate}}</p>
            </div>
          </div>
  
          <p style="border-bottom:1px solid #d1d1d1;">Address</p>
          <div class="row d-flex justify-content-between mt-4 mb-3">
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
              <h6>From</h6>
              Brightspeed<br>
              P.O. Box 2677<br>
              Fayetteville, NC 28302-2677
            </div>
            <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head" style="text-transform: capitalize;">
              <h6>To</h6>
              {{invoice.businessPartnerName}}<br>
              {{invoice.StreetName}}<br>
              {{invoice.CityName}}, {{invoice.region}} {{invoice.zipCode}}
            </div>
            <div class="col-sm-12 col-md-3"></div>
            <div class="col-sm-12 col-md-3"></div>
          </div>
  
          <div *ngIf="invoiceDetailsReceived">
            <div class="charge-actions">
              <p >Charges</p>
              <div (click)="downloadCSV()" class="download-button" tabindex="0" ngbTooltip="Download Charge Data as CSV" [ngClass]="{ 'disable': (invoiceItemData.length==0)}">
                <svg class="me-3" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="40" id="download" viewBox="0 0 48 48">
                    <path d="M 23.970703 5.9726562 A 2.0002 2.0002 0 0 0 22 8 L 22 27.171875 L 19.414062 24.585938 A 2.0002 2.0002 0 1 0 16.585938 27.414062 L 22.585938 33.414062 A 2.0002 2.0002 0 0 0 25.414062 33.414062 L 31.414062 27.414062 A 2.0002 2.0002 0 1 0 28.585938 24.585938 L 26 27.171875 L 26 8 A 2.0002 2.0002 0 0 0 23.970703 5.9726562 z M 7.9707031 30.972656 A 2.0002 2.0002 0 0 0 6 33 L 6 36 C 6 39.290032 8.7099679 42 12 42 L 36 42 C 39.290032 42 42 39.290032 42 36 L 42 33 A 2.0002 2.0002 0 1 0 38 33 L 38 36 C 38 37.127968 37.127968 38 36 38 L 12 38 C 10.872032 38 10 37.127968 10 36 L 10 33 A 2.0002 2.0002 0 0 0 7.9707031 30.972656 z"></path>
                </svg>
            </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <table class="table">
                  <thead>
                      <tr>
                        <th>Charge Name</th>
                          <th>Charge Date</th> 
                          <th>Service Period</th>
                          <th>Quantity</th>
                          <th>Amount</th>   
                          <th>Tax</th>
                          <th>Total</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let item of invoiceItemData">
                          <td>{{ item.CHARGE_NAME }}</td>
                          <td>{{ item.CHARGEDATE ? (transformInvoiceDate(item.CHARGEDATE) | date: 'MM/dd/yyyy') : '' }}</td> 
                          <td>{{  item.SERVICE_PERIOD ? formatServicePeriod(item.SERVICE_PERIOD) : '' }}</td>
                          <td>{{ item.QUANTITY }}</td>
                          <td>{{ item.AMOUNT }}</td>
                          <td>{{ item.TAX }}</td>
                          <td>{{ item.TOTAL }}</td>
                           
                      </tr>
                  </tbody>
              </table>
              
              
                <div class="total-amount">
                  <strong>Total Invoice Amount:</strong> {{ totalInvoiceAmount | currency }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



